import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";

export function useArchiveToggleContactGroup(contactGroupID: string, refetch: () => void) {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const submit = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            await platformAPI.post(`api/contact-groups/${contactGroupID}/archive-toggle`);
            refetch();
            return true;
        } catch (e) {
            if (isAxiosError(e) && e?.response?.data?.error) {
                setError(e.response.data.error);
            } else {
                setError("error updating contact group");
            }
            return false;
        } finally {
            setLoading(false);
        }
    }, [contactGroupID, refetch]);

    return {submit, error, loading};
}
